<template>
  <div class="person-right">
    <div class="maintop">
        <span>基本信息</span>
    </div>
    <el-divider></el-divider>
    <div class="my-flex">
      <el-form
        style="margin-left:0;padding:14px 155px 45px 80px;border: 1px solid #EDEDED;width:100%"
        label-width="130px"
        size="small"
        :model="formData"
        :rules="rules"
        ref="ruleFormUserInfo"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item  label="姓名" prop="name">
              <el-input v-model="formData.name" disabled></el-input>
              <!-- <span style='color:red;margin-left:10px;'>* 需与证件上的姓名一致</span> -->
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
            <el-col :span="12">
                <el-form-item label="证件类型" prop="certType" >
                  <el-select v-model="formData.certType" style="width:100%" disabled>
                    <el-option
                      v-for="item in certTypeList"
                      v-show="item.enumText!='营业执照'"
                      :key="item.enumValue"
                      :label="item.enumText"
                      :value="item.enumValue">
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="证件号码" prop="certNo">
                  <el-input v-model="formData.certNo" style="width:100%" disabled></el-input>
                </el-form-item>
            </el-col>            
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="formData.sex" style="width:100%" :disabled="formData.certType == 0">
                <el-option
                  v-for="item in sexlist"
                  :key="item.enumValue"
                  :label="item.enumText"
                  :value="item.enumValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生年月" prop="birthDay">
              <el-date-picker  style="width:100%"
                v-model="formData.birthDay"
                type="date"
                 :disabled="formData.certType == 0">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="民族" prop="nation">
              <el-select v-model="formData.nation" style="width:100%" filterable>
                <el-option
                  v-for="item in nationlist"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>          
          <el-col :span="12">
              <el-form-item label="婚姻状况" prop="maritalStatus">
                <el-select v-model="formData.maritalStatus" style="width:100%">
                  <el-option
                    v-for="item in marriagelist"
                    :key="item.enumValue"
                    :label="item.enumText"
                    :value="item.enumValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
        </el-row>
       
        <el-row>            
            <el-col :span="12">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input v-model="formData.mobile" maxlength="50" style="width:100%" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
            <el-form-item label="固定电话">
                <el-input v-model="formData.telephone" maxlength="13" style="width:100%"></el-input>
              </el-form-item>
            </el-col>            
        </el-row>
        <el-row>          
          <el-col :span="12">
              <el-form-item label="Email：" prop="email">
                <el-input v-model="formData.email" maxlength="50" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          <el-col :span="12">
            <el-form-item label="政治面貌" prop="politicalStatus">
              <el-select v-model="formData.politicalStatus"  style="width:100%">
                <el-option
                  v-for="item in politicalList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>          
          <el-col>
            <el-form-item label="户籍地址">
              <el-input v-model="formData.liveAddress" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>          
          <el-col :span="12">
            <el-form-item label="户口性质">
              <el-select v-model="formData.identityType" style="width:100%">
                <el-option
                  v-for="item in identitytypelist"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户籍邮编">
              <el-input v-model="formData.liveZip" maxlength="6" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>          
          <el-col>
            <el-form-item label="居住(通讯)地址">
              <el-input v-model="formData.currentAddress" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>          
          <el-col :span="12">
            <el-form-item label="居住地邮编">
              <el-input v-model="formData.currentZip" maxlength="6" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-divider></el-divider>
            <el-form-item style="margin: 20px 0px 20px 0px;padding: 0px; text-align:center;">
              <el-button type="primary" :loading="loading" v-on:click="submit()">确认修改</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style></style>
<script>
import { getUserInfo,removeUserInfo } from "@/store/index";
import { isEmail, isMobile } from "@/helper/validate";
import { post } from "@/api/common/index";
export default {
  inject: ["reload"],
  data() {
    return {
      formData: {
        id: "",
        userPhotoName: "", // 图片文件名
        userPhoto: "",     // 图片URL链接
        userAccount: "",
        name: "",
        sex: 0,
        certType: "",
        certNo: "",
        birthDay: "",
        email: "",
        mobile: "",
        currentAddress: "",
        password: "",
        nation:'',
        maritalStatus:'',
        telephone:'',
        liveAddress:'',
        identityType:'',
        liveZip:'',
        currentZip:'',
        politicalStatus:""
      },
      fileInfo: {
        fileName: "",
        fileContent: "",
        file_base64_content: "",
      },
      tempFileName: "",
      loading:false,
      rules: {
        name:[{required: true , message: "请填写姓名"}],
        certType:[{required: true , message: "请选择证件类型"}],
        certNo:[{required: true , message: "请填写证件号码"}],
        sex:[{required: true , message: "请选择性别"}],
        nation:[{required: true , message: "请选择民族"}],
        birthDay:[{required: true , message: "请填写出生日期"}],
        maritalStatus:[{required: true , message: "请选择婚姻状况"}],
        politicalStatus:[{required: true , message: "请选择政治面貌"}],
        mobile: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入手机号码！"));
              } else if (!isMobile(value)) {
                callback(new Error("手机号码格式不正确！"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入邮箱！"));
              } else if (!isEmail(value)) {
                callback(new Error("邮箱格式不正确！"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },

      sexlist:[],
      nationlist:[],
      marriagelist:[],
      identitytypelist:[],
      certTypeList:[],
      politicalList:[]
    };
  },
  activated() {
    this.init();
    this.getSexStatus()
    this.getNationStatus()
    this.getMarriageStatus()
    this.getPoliticalStatus()
    this.getIdentityTypeStatus()
    this.getCertType()
  },
  methods: {
    init: function () {
      getUserInfo().then((data) => {
        this.formData = data;       
        
        this.$nextTick(()=>{
          if(this.$refs["ruleFormUserInfo"]){
            this.$refs["ruleFormUserInfo"].clearValidate();
          }
        });
      });
    },
    submit() {
      this.loading = true;
      var vm = this;

      this.$refs["ruleFormUserInfo"].validate((valid) => {
        if(valid){
            post("/api/user/update_user_info", vm.formData)
            .then((res) => {
                if (res.success) {
                    this.$message({
                      message: "修改成功",
                      type: "success",
                    });
                    removeUserInfo();
                    this.init();
                    this.reload();
                } else {
                    this.$message.error(res.reason);
                    this.loading = false;
                }
            },(err)=>{
              this.$message.error(err);
              this.loading = false;
            })
            .catch((error) => {
                this.$message.error(error);
                this.loading = false;
            });
        }
        else{
          this.loading = false;
        }
      });      
    },
    //获取性别列表
    getSexStatus(){
      this.sexlist = this.$Global.enum.AllowSex;
    },
    //获取民族列表
    getNationStatus(){
      this.nationlist = this.$Global.syscode.Nation;
    },
    //获取婚姻状况列表
    getMarriageStatus(){
      this.marriagelist = this.$Global.enum.MaritalStatus;
      this.marriagelist.forEach(function(ele){
          ele.enumValue = ele.enumValue.toString();
      });
    },
    //获取政治面貌列表
    getPoliticalStatus(){
      this.politicalList = this.$Global.syscode.PoliticalStatus;
    },
    //获取户口性质列表
    getIdentityTypeStatus(){
      this.identitytypelist = this.$Global.syscode.IdentityType;
    },
    //获取证件类型列表
    getCertType(){
      this.certTypeList = this.$Global.enum.CertType;
    }
  },
};
</script>

<style scoped>
.el-divider{
    margin: 0;
}
.el-col {
  padding-top: 10px;
}

.el-form-item__label {
  font-weight: 400;
  color: #333333;
  font-size: 14px;
}

.el-form-item__content {
  font-weight: 400;
  color: #666666;
  font-size: 14px;
}
</style>